import { useEffect } from "react";

import { useParams } from "react-router-dom";

import useNavigation from "./navigation";
import { useTeam } from "./useTeams";

export const useGuardPrivateCloudTeams = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const { teamID } = useParams();
  const { teamData } = useTeam(teamID);
  const navigation = useNavigation();

  const shouldRedirect = teamData?.addons?.privateCloud && teamID && enabled;
  useEffect(() => {
    if (shouldRedirect) {
      navigation.goToSharedWithMe({ teamID });
    }
  }, [shouldRedirect, navigation, teamID]);

  return shouldRedirect;
};
